__turbopack_context__.v({
  "container": "MasterplanBlock-module__uHLEZq__container",
  "container__image": "MasterplanBlock-module__uHLEZq__container__image",
  "container__info": "MasterplanBlock-module__uHLEZq__container__info",
  "container__info__list": "MasterplanBlock-module__uHLEZq__container__info__list",
  "container__info__title": "MasterplanBlock-module__uHLEZq__container__info__title",
});
